.root {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.slotRow {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
  flex-wrap: wrap;
}

@media (max-width: 599.95px) {
  .slotRow {
    align-items: flex-start;
    flex-direction: column;
  }
}
